var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconTrauma128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_10523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.783 46.5029C110.468 48.0746 113 51.3353 113 55.1029V85.9029C113 89.6705 110.468 92.9312 106.783 94.5029M21.2173 46.5029C17.5321 48.0746 15 51.3353 15 55.1029V85.9029C15 89.6705 17.5321 92.9312 21.2173 94.5029",
    stroke: "#1E1E1E",
    strokeWidth: 1.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.178 33.5029H24.8222C22.7113 33.5029 21 35.3308 21 37.5857V103.42C21 105.675 22.7113 107.503 24.8222 107.503H103.178C105.289 107.503 107 105.675 107 103.42V37.5857C107 35.3308 105.289 33.5029 103.178 33.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 23.9163V33.3029C71.8667 33.3029 86.8 33.3029 86.8 33.3029C86.8 30.174 86.8 27.0452 86.8 23.9163C86.8 22.0311 85.1954 20.5029 83.216 20.5029H45.584C43.6046 20.5029 42 22.0311 42 23.9163Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.85,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6 51.5029H57.8074V64.3029H45V77.1029H57.8074V89.9029H70.6V77.1029H83.4V64.3029H70.6V51.5029Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_10523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconTrauma128);
export default __webpack_public_path__ + "static/media/pictogramBeaconTrauma128.d087badafa3caac4a9a052c8e0228d23.svg";
export { ForwardRef as ReactComponent };